module.exports = __webpack_public_path__ + "static/media/withdraw.54526383.svg";